import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { BillingAccessGuard } from 'modules/billing/components/BillingAccessGuard';
import { Page } from 'modules/layout/components/Page';
import { homeRoutesConfig } from 'domains/home/routes';

const CardPaymentFailurePage = loadable(
  async () => {
    const module = await import('./CardPaymentFailurePage');

    return module.CardPaymentFailurePage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);
const homePath = homeRoutesConfig.home.generatePath();

export const CardPaymentFailurePageContainer = () => {
  return (
    <Page>
      <BillingAccessGuard fallback={<Navigate to={homePath} replace />}>
        <CardPaymentFailurePage />
      </BillingAccessGuard>
    </Page>
  );
};
